export default function() {
  'ngInject';
  return {
    require: 'ngModel',
    link: function(scope, element, attrs, ngModel) {
      'ngInject';
      ngModel.$parsers.push(function(val) {
        return val != null ? parseInt(val, 10) : null;
      });
      ngModel.$formatters.push(function(val) {
        return val != null ? '' + val : null;
      });
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/directives/convertToNumber/index.js